import clsx from 'clsx';
import React, { useState, MouseEvent } from 'react';
import { BsThreeDots } from 'react-icons/all';
import ClickOutHandler from 'react-onclickout';
import './MoreActionMenu.scss';

interface Props {
  menuSide: 'left' | 'right';
  actionList: ActionListMenu[];
  className?: string;
}

export interface ActionListMenu {
  text?: string;
  clickAction?: (e: MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  horizontalLine?: boolean;
  style?: { [key: string]: string };
}

const MoreActionMenu = (props: Props) => {
  const { actionList, menuSide } = props;
  const [isOpenMenu, toggleMenu] = useState<boolean>(false);
  const onClickOut = () => toggleMenu(false);
  return (
    <ClickOutHandler onClickOut={onClickOut}>
      <div
        className={clsx('more-action-list-container', props.className)}
        onClick={event => {
          event.stopPropagation();
          toggleMenu(!isOpenMenu);
        }}
      >
        <BsThreeDots />
        {isOpenMenu ? (
          <div
            className={`more-action-list ${menuSide}`}
            onClick={e => e.stopPropagation()}
          >
            {actionList.map((action, ix) => (
              <div
                key={`${ix}_${action.text}`}
                className={
                  action.horizontalLine
                    ? 'horizontal-line'
                    : action.disabled
                    ? 'list-item disabled'
                    : 'list-item'
                }
                onClick={e => {
                  e.stopPropagation();
                  toggleMenu(false);
                  if (!action.disabled) {
                    action.clickAction(e);
                  }
                }}
              >
                {action.horizontalLine ? null : (
                  <span style={action.style}>{action.text}</span>
                )}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </ClickOutHandler>
  );
};

export default MoreActionMenu;
